﻿import React, {Component} from 'react';
import RolesList from './roles-list'
import { IconButton } from 'material-ui';
import AddIcon from 'material-ui/svg-icons/content/add';
import ListAppBar from '../core/list-app-bar';

class Roles extends Component {
    render() {
        return (
            <div>
                <ListAppBar title="Roles"
                        iconElementRight={
                            <IconButton href={'/role/0'}><AddIcon /></IconButton>
                        }
                />
                <RolesList />
            </div>

        )
    }
}

Roles.contextTypes = {
    router: React.PropTypes.any.isRequired
};

export default Roles;